import type { Task } from '@obv/api-client';
import { zonedParts } from '@obv/core';
import { useCallback } from 'react';
import { useHabitLogs, useHabits, useTasks } from '@/queries/chores';
import { useDisplay } from './context';

/** Tasks for the display, with completion dates resolved in the household's time zone. */
export function useChoreData() {
  const ctx = useDisplay();
  const tz = ctx.tz;
  const completedOn = useCallback((t: Task) => (t.completed_at ? zonedParts(new Date(t.completed_at), tz).dateKey : null), [tz]);
  const tasks = useTasks(ctx.clock.dateKey, ctx.boot.server_time, completedOn);
  return { tasks, completedOn };
}

export function useHabitData() {
  const ctx = useDisplay();
  const habits = useHabits();
  const logs = useHabitLogs(ctx.clock.dateKey);
  return { habits, logs };
}
